import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
import moment from "moment/moment";
import "../offerprice/salehistory/index.css";

// components
import PaginationHelper from "../../components/PaginationHelper";
import AnimationLoading from "../../components/Animationloading";

// apollo-client
import { useLazyQuery, useMutation } from "@apollo/client";

// Icons
import SearchIcon from "@mui/icons-material/Search";

// Bootrap
import {
  Form,
  Row,
  InputGroup,
  Col,
  Table,
  Modal,
  Button,
} from "react-bootstrap";
import BreadCrumbComponent from "../../components/BreadCrumbComponent";
import { toast } from "react-toastify";

import {
  APP_COLOR,
  BLUETOOTH_PORT,
  ENTERNET_PORT,
  LINEAR_GRADIENT_BG,
  USB_PORT,
} from "../../const";
import {
  base64ToBlob,
  convertCurrency,
  covertTimeZone,
  numberFormat,
} from "../../helper";
import CustomButton from "../../components/CustomButton";
import {
  DELETE_PRODUCT_FORM_DB,
  RECOVER_PRODUCT_OLD,
} from "../../apollo/product/Mutation";
import ComfirmModal from "../../components/ComfirmModal";
import { successDeleteSwal } from "../../helper/sweetalert";
import {
  // MdAutorenew,
  // MdDelete,
  MdPrint,
  MdDownload,
  // MdOutlineMoneyOff,
  MdDateRange,
} from "react-icons/md";
// import { Alert } from "antd";
import { GET_ORDER_GROUPS_V2 } from "../../apollo/ordergroup/query";
import BillforSale80 from "../../components/bill/BillforSale80";
import ReactToPrint from "react-to-print";
import { useHistory, useLocation } from "react-router-dom";
// import { BsFillCheckCircleFill } from "react-icons/bs";
import Swal from "sweetalert2";
import axios from "axios";
import html2canvas from "html2canvas";
// import jsPDF from "jspdf";
import { GET_PRINTERS } from "../../apollo/printer/Query";
import * as XLSX from "xlsx";
import CurrentDateComponents from "../../components/CurrentDateComponents";
import _ from "lodash";
import { GET_USER_TYPE } from "../../apollo/userType/mutation";
import { GET_CATEGORYS } from "../../apollo/category/query";
import { GET_EXCHANGE_RATE } from "../../apollo/product/query";

export default function FlyReport() {
  const history = useHistory();
  const location = useLocation();

  const [orderGroups, setOrderGroups] = useState([]);
  const [productDeletedTotal, setOrderGroupsTotal] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const [activeButton, setActiveButton] = useState("thisMonth");

  const [cdFillter, setCdFillter] = useState({
    createdAt_gte: "",
    createdAt_lt: "",
  });

  const [status, setStatus] = useState("");
  const [searchText, setSearchText] = useState("");
  const { _limit, _skip, Pagination_helper } = PaginationHelper();

  let bill80Ref = useRef(null);
  let bill58Ref = useRef(null);
  const printRef = useRef();

  const [openBillOrder, setOpenBillOrder] = useState(false);
  const [openComfirmModal, setOpenComfirmModal] = useState(false);
  const [subTotal, setSubTotal] = useState({
    kip: 0, baht: 0, usd: 0
  });
  const [openRecoverComfirm, setOpenRecoverComfirm] = useState(false);
  const [isSelectAll, setIsSelectAll] = useState(false);
  const [dataForRetrun, setDataForRetrun] = useState([]);
  const [preOrderGroups, setPreOrderGroups] = useState();
  const [printer, setPrinter] = useState();
  const [widthBill80, setWidthBill80] = useState(0);
  const [widthBill58, setWidthBill58] = useState(0);
  const [isCurrentModals, setIsCurrentModals] = useState(false);

  //? user type useState
  const [newUserTypeData, setNewUserTypeData] = useState([]);

  const [getExchangeRate, { data: exchangeRateData }] = useLazyQuery(GET_EXCHANGE_RATE, { fetchPolicy: "cache-and-network" });
  const exchangeRateByShop = exchangeRateData?.exchangeRate || {};
  const calculateSumInLAKFromOrders = (orders = []) => {
    return orders.reduce((sum, order) => {
      const base = parseFloat(order?.totalPrice || 0);
      const cur = order?.currency || order?.stock?.currency;
      if (cur === "LAK" || cur === "ກີບ") return sum + base;
      if (cur === "BAHT" || cur === "ບາດ") return sum + base * parseFloat(exchangeRateByShop?.baht || 1);
      if (cur === "USD" || cur === "ໂດລາ") return sum + base * parseFloat(exchangeRateByShop?.usd || 1);
      return sum + base;
    }, 0);
  };
  const [selectUserType, setSelectUserType] = useState("");

  //? category useState
  const [newCategoryData, setNewCategoryData] = useState([]);
  const [selectCategory, setSelectCategory] = useState("");

  // const [productPreId, setProductPreId] = useState("");
  let shopId = JSON.parse(localStorage.getItem("SHOP_DATA"))?.id;

  // ============== > UseLazyQuery And UseMutaion <============== 

  const [getCategory] = useLazyQuery(GET_CATEGORYS, { fetchPolicy: "cache-first",
    onCompleted: (data) => {
      if (data?.categories?.data?.length > 0) {
        setNewCategoryData(data?.categories?.data);
      }
    }
  });

  const [getPrinterDatas, { data: printerDatas }] =
    useLazyQuery(GET_PRINTERS, { fetchPolicy: "network-only" });

  const [deleteProductFromDB, { loading: loadingDeleted }] = useMutation(
    DELETE_PRODUCT_FORM_DB
  );

  const [recoverProduct, { loading: loadingRecover }] =
    useMutation(RECOVER_PRODUCT_OLD);

  const [
    getOrderGroupsSale,
    { data: orderGroupsSale, loading: loadingOrderGroups },
  ] = useLazyQuery(GET_ORDER_GROUPS_V2, { fetchPolicy: "cache-first" });
  // const [
  //   getOrderGroupsSale,
  //   { data: orderGroupsSale, loading: loadingOrderGroups },
  // ] = useLazyQuery(GET_ORDERGROUPS, { fetchPolicy: "cache-and-network" });

  const [userTypeData] =
      useLazyQuery(GET_USER_TYPE, { fetchPolicy: "cache-first", onCompleted: (data) => {
        const userType = data?.getUserTypes.filter((item) => item?.isOpen);
        setNewUserTypeData(userType);
      } });


  // ============== > useEffect <==============

  useEffect(() => {
    if (orderGroupsSale) {
      const exchangeRateBaht = parseFloat(exchangeRateByShop?.baht || 1);
      const exchangeRateUsd = parseFloat(exchangeRateByShop?.usd || 1);

      const kip = orderGroupsSale?.orderGroupsV2?.data.reduce((total, item) => {
        const sumPriceKip = parseFloat(item?.sumPrice || 0);
        const sumPriceBaht = parseFloat(item?.sumPriceBaht || 0);
        const sumPriceUsd = parseFloat(item?.sumPriceUsd || 0);

        return total + sumPriceKip + sumPriceBaht * exchangeRateBaht + sumPriceUsd * exchangeRateUsd;
      }, 0);
      // const baht = orderGroupsSale?.orderGroups?.data.reduce(
      //   (total, item) => total + parseInt(item?.sumPriceBaht || 0), 0
      // );
      // const usd = orderGroupsSale?.orderGroups?.data.reduce(
      //   (total, item) => total + parseInt(item?.sumPriceUsd || 0), 0
      // );
      setSubTotal({
        kip: kip || 0,
        // baht: baht || 0,
        // usd: usd ||0
      });
      setOrderGroups(orderGroupsSale?.orderGroupsV2?.data);
      setOrderGroupsTotal(orderGroupsSale?.orderGroupsV2?.total);
      setTotalAmount(orderGroupsSale?.orderGroupsV2?.data.reduce(
        (total, item) => total + parseInt(item?.amount || 0), 0
      ));
    }
  }, [orderGroupsSale, exchangeRateData]);


  //   console.log("result: ", getproducthistoryData);
  useLayoutEffect(() => {
    setWidthBill80(bill80Ref?.current?.offsetWidth);
    setWidthBill58(bill58Ref?.current?.offsetWidth);
  }, [bill80Ref, bill58Ref]);


  useEffect(() => {
    if (newCategoryData.length <= 0) {
      getCategory({
        variables: {
          limit: 100,
          where: {
            shop: shopId,
            isDeleted: false,
          },
        },
      });
    }
    _fetchPrinter();
    if (!exchangeRateData) {
      getExchangeRate({
        variables: {
          where: { shop: shopId },
        },
      });
    }
  }, []);


  useEffect(() => {
    fetchOrderGroups();
  }, [searchText, cdFillter, _skip, selectUserType, status, selectCategory]);
 
  // ============== > fuctions <==============

  const _fetchPrinter = async () => {
    await getPrinterDatas({
      variables: {
        where: {
          shop: shopId,
          isDeleted: false,
        },
      },
    });
  };

  const fetchOrderGroups = async (_values) => {
    try {
      let shopId = JSON.parse(localStorage.getItem("SHOP_DATA"))?.id;
      let _where = {
        shop: shopId,
        isDeleted: false,
        type:"POS"
      };

      // Check if search text is not empty
      if (searchText && searchText.trim() !== "") {
        _where.customerName = searchText;
      }

      // Check if filter date is set
      if (cdFillter) {
        _where.createdAt_gte = new Date(
          moment(cdFillter?.createdAt_gte).format("YYYY-MM-DD")
        ).toISOString();
        _where.createdAt_lt = new Date(
          moment(cdFillter?.createdAt_lt).add(1, "days").format("YYYY-MM-DD")
        ).toISOString();
      }
      

      if (status !== "") { _where = { ..._where, status: status } };

      if (selectUserType !== "") { _where = { ..._where, userType: selectUserType } };

      if (selectCategory !== "") { 
        const category = newCategoryData?.find((e) => e?.id === selectCategory);
        _where = { ..._where, 
          category: category?.id,
          categoryName: category?.name, 
        } 
      };

      // Determine the limit value
      const limitValue = !_.isEmpty(_values) ? parseInt(_values, 10) : _limit;

      // Define variables for the query
      const variables = {
        where: _where,
        skip: (_skip - 1) * limitValue,
        limit: limitValue,
        orderBy: "createdAt_DESC",
      };

      // Get all order groups
      await getOrderGroupsSale({
        variables,
      });

      //TODO Fetch user type data
      if(newUserTypeData.length <= 0 && selectUserType === ""){
        await userTypeData()
      }
    } catch (error) {
      console.log("Error: ", error);
    }
  };


  //   deleted product from database
  const deletedProductFormDB = async () => {
    try {
      // console.log("dataFroRetrun------>", dataForRetrun)
      const _ids = await dataForRetrun.map((data) => data?.id);
      const req = await deleteProductFromDB({
        variables: {
          where: {
            id_in: _ids,
          },
        },
      });
      if (req) {
        successDeleteSwal("ສິນຄ້າຖຶກລົບອອກຈາກລະບົບແລ້ວ");
        setOpenComfirmModal(false);
        // fetchProductDeleted();
        setDataForRetrun([]);
        setIsSelectAll(false);
        // setIsAlert(true)
      }
    } catch (error) {
      console.log("error:-->", error);
    }
  };

  //   recover product ------------>
  const handleRecoverProductOld = async () => {
    try {
      if (loadingRecover) return;
      const _ids = await dataForRetrun.map((data) => data?.id);
      await recoverProduct({
        variables: {
          where: {
            id_in: _ids,
          },
        },
      });
      setDataForRetrun([]);
      setOpenRecoverComfirm(false);
      successDeleteSwal("ກູ້ຄືນສຳເລັດແລ້ວ");
      // fetchProductDeleted();
      setIsSelectAll(false);
      // setIsAlert(true)
    } catch (err) {
      console.log("error:", err);
    }
  };

  //   console.log("GetProductData====55555>", GetProductData);

  //   select all items
  // const handleSelectAllItems = () => {
  //   // console.log("order----->: ", ordergroupData?.orders);
  //   if (isSelectAll) {
  //     setIsSelectAll(false);
  //     setDataForRetrun([]);
  //   } else {
  //     // const _dataForReturn = ordergroupData?.orders.map((order) => order.id);
  //     setIsSelectAll(true);
  //     // console.log("returnOrderAll====>", _dataForReturn);
  //     setDataForRetrun(orderGroups);
  //   }
  // };

  //   select single item
  const handleSelectSingleItems = (e) => {
    const orderId = e.id; // Replace 'id' with the actual property name

    setDataForRetrun((prevSelected) => {
      // Check if the item is already in the selectedItems array
      const isSelected = prevSelected.some((item) => item.id === orderId);

      // If it's selected, remove it; otherwise, add it to the selectedItems array
      if (isSelected) {
        return prevSelected.filter((item) => item.id !== orderId);
      } else {
        return [...prevSelected, e];
      }
    });
  };

  const onViewOrderGroups = (item) => {
    setPreOrderGroups(item);
    setOpenBillOrder(true);
  };

  useEffect(() => {
    if (printerDatas) setPrinter(printerDatas?.printers?.data);
  }, [printerDatas]);

  const onPrintBill = async () => {
    try {
      console.log("printer:======>", printer)
      let urlForPrinter = "";
      const printerBillData = printer?.find((e) => e?.status === true);

      console.log({ printerBillData });

      let dataImageForPrint;
      if (printerBillData?.width === "80mm") {
        dataImageForPrint = await html2canvas(bill80Ref.current, {
          useCORS: true,
          scrollX: 10,
          scrollY: 2,
          scale: 560 / widthBill80,
        });
      }
      // console.log({ dataImageForPrint })

      if (printerBillData?.width === "58mm") {
        dataImageForPrint = await html2canvas(bill58Ref.current, {
          useCORS: true,
          scrollX: 10,
          scrollY: 0,
          scale: 350 / widthBill58,
        });
      }
      if (printerBillData?.type === "ETHERNET") {
        urlForPrinter = ENTERNET_PORT;
      }
      if (printerBillData?.type === "BLUETOOTH") {
        urlForPrinter = BLUETOOTH_PORT;
      }
      if (printerBillData?.type === "USB") {
        urlForPrinter = USB_PORT;
      }

      console.log("checkImgePrinter:--->", dataImageForPrint);
      const _file = await base64ToBlob(dataImageForPrint.toDataURL());
      var bodyFormData = new FormData();
      bodyFormData.append("ip", printerBillData?.ip);
      bodyFormData.append("port", "9100");
      bodyFormData.append("image", _file);
      bodyFormData.append("beep1", 1);
      bodyFormData.append("beep2", 9);

      await axios({
        method: "post",
        url: urlForPrinter,
        data: bodyFormData,
        headers: { "Content-Type": "multipart/form-data" },
      });

      await Swal.fire({
        icon: "success",
        title: "ປິນສຳເລັດ",
        showConfirmButton: false,
        timer: 1500,
      });
    } catch (err) {
      console.log(err);
      await Swal.fire({
        icon: "error",
        title: "ປິນບໍ່ສຳເລັດ",
        showConfirmButton: false,
        timer: 1500,
      });
    }
  };

  //   Process order groups by filtering out specific properties from each order and each order group, then maps the remaining properties.
  const processOrderGroups = (data) =>
    data.map(
      ({ __typename, orders, shop, status, id, updatedAt, ...orderGroup }) => ({
        ...orderGroup,
        orders:
          orders?.map(
            ({
              __typename,
              id,
              stock,
              type,
              isDeleted,
              isPaymented,
              phone,
              totalPriceBaht,
              totalPriceUsd,
              note,
              ...restOfOrder
            }) => restOfOrder
          ) ?? [],
      })
    );

  // Translates order group data fields from English to Lao.
  const translateDataFieldsToLao = (data) =>
    data.map((item) => ({
      ລະຫັດອໍເດີ້: item?.code,
      ຊື່ລູກຄ້າ: item?.customerName
        ? item?.customerName + " " + item?.customerLastName
        : "-",
      ປະເພດລູກຄ້າ: item?.userConfirm?.userType?.name,
      ເບີໂທລະສັບ: item?.phone ?? "-",
      ບ້ານ: item?.village ?? "-",
      ເມືອງ: item?.district ?? "-",
      ແຂວງ: item?.province ?? "-",
      ຈຳນວນທັງໝົດ: numberFormat(item?.amount),
      ຊຳລະ: item?.payment === "CASH" ? "ເງິນສົດ" : "ເງິນໂອນ",
      ເງິນລວມທັງໝົດ:
        convertCurrency(item?.currency) + " " + numberFormat(item?.sumPrice),
      ເງິນລວມໂດລາ: "$ " + numberFormat(item?.sumPriceUsd),
      ເງິນລວມບາດ: "฿ " + numberFormat(item?.sumPriceBaht),
      ເງິນລວມກີບ:
        convertCurrency(item?.currency) + " " + numberFormat(item?.totalPrice),
      ຊື່ພະນັກງານຂາຍ: item?.staff + " " + item?.staffLastname ?? "-",
      ວັນທີສ້າງ: covertTimeZone(item?.createdAt),
      ອໍເດີ້ທັງໝົດ: item.orders.map((order, _index) => ({
        ຈຳນວນ: numberFormat(order?.amount),
        ຊື່ສິນຄ້າ: order?.productName,
        ລາຄາ:
          convertCurrency(order?.currency) + " " + numberFormat(order?.price),
        ຈຳນວນເງິນ: numberFormat(order?.totalPrice),
      })),
    }));

  const onDownloadToExcelFile = async () => {
    try {

      const processedData = processOrderGroups(orderGroups);

      const translatedData = translateDataFieldsToLao(processedData);

      // console.log("translatedData:===>", translatedData);
      const workbook = XLSX.utils.book_new();
      const rows = [];

      // Iterate over translated data to manually add rows for order groups and their orders
      translatedData.forEach((group, index) => {
        // Add the order group as a row
        rows.push({
          // Spread the group info here; adjust according to your actual structure
          ລຳດັບ: index + 1,
          ...group,
          ອໍເດີ້ທັງໝົດ: "ລາຍການທີສັ່ງຊື້:", // Assuming you want to keep this structure. Adjust as needed.
        });
        // Add each order as a row, indent or prefix to indicate the hierarchy
        group["ອໍເດີ້ທັງໝົດ"].forEach((order) => {
          rows.push({
            ...order,
            ຊື່ສິນຄ້າ: `    ${order["ຊື່ສິນຄ້າ"]}`, // Example of indentation
          });
        });
      });
      const worksheet = XLSX.utils.json_to_sheet(rows);

      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

      XLSX.writeFile(workbook, "ລາຍງານການຂາຍ.xlsx");

      await toast.success(`ການດາວໂຫຼດ ເປັນຟາຍ excel ໄດ້ແລ້ວ!`,
        {
          position: "top-center",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        })
    } catch (error) {
      console.error({ error });
    }
  };

  // const onDownloadToPDFFile = async () => {
  //   try {
  //     const processedData = processOrderGroups(orderGroups);

  //     const translatedData = translateDataFieldsToLao(processedData);

  //     generatePDF(translatedData);

  //     await toast.success('ການດາວໂຫຼດ ເປັນຟາຍ PDF ໄດ້ແລ້ວ!', {
  //       position: "top-center",
  //       autoClose: 1500,
  //       hideProgressBar: false,
  //       closeOnClick: true,
  //       pauseOnHover: true,
  //       draggable: true,
  //       progress: undefined,
  //       theme: "light",
  //     });
  //   } catch (error) {
  //     console.error({ error });
  //   }
  // };


  const handleSelectLimit = (e) => {
    const _values = e?.target?.value;
 
    // Extract the current pathname
    let pathname = location.pathname;

    // Use regular expression to replace the limit value in the URL
    pathname = pathname.replace(/(\/limit\/)\d+/, `/limit/${_values}`);

    // Reset page to 1 whenever limit changes
    pathname = pathname.replace(/(\/page\/)\d+/, '/page/1');

    // Replace the current entry in the history stack
    history.replace(pathname);

    // Optionally, call the filterOrderGroups function if needed
    fetchOrderGroups(_values);
  }; 

  return (
    <React.Fragment>
      <div className="sale-history-mains">
        <BreadCrumbComponent
          // goback={() => history.goBack()}
          // txtFirst="ປະຫວັດການຂາຍ"
          txtSecond={`ລາຍງານການຂາຍ`}
        />
        {/* {isAlert && <div style={{marginTop:'-1em',padding:'0 2em'}}>
          <Alert message="ກູ້ຄືນສະຕ໋ອກສຳເລັດແລ້ວ" closable  type="success" showIcon />
        </div>} */}

        {/* <div style={{ padding: "1em 2em" }}>
          <h4>
            <b>ລາຍການບິນຫຼັງການຂາຍ</b>
          </h4>
          <p>
            ສິນຄ້າທີ່ຖຶກລົບທັງໝົດ ຈະເກັບໄວ້ໃນລະບົບ ເພື່ອກວດຄືນ ປະຫວັດການລົບ.
          </p>
        </div> */}

        <div style={{ padding: "0 2em" }}>
          <Row>
            {/* <Col className="col-4"></Col> */}
            <Col md={3}>
              <Form.Label htmlFor="basic-url">ຄົ້ນຫາ</Form.Label>
              <InputGroup className="mb-3">
                <InputGroup.Text
                  style={{
                    backgroundColor: "#FFFFFF",
                  }}
                >
                  <SearchIcon sx={{ color: "#6B7280" }} />
                </InputGroup.Text>
                <Form.Control
                  id="basic-url"
                  onChange={(e) => {
                    setSearchText(e?.target?.value);
                  }}
                  value={searchText}
                  aria-describedby="basic-addon3"
                  placeholder="ຄົ້ນຫາດ້ວຍຊື່ລູກຄ້າ"
                />
              </InputGroup>
            </Col>
            {/* Category Filter */}
            <Col md={2}>
              <Form.Label>ປະເພດສີນຄ້າ</Form.Label>
                <Form.Select
                  name="category"
                  onChange={(e) => setSelectCategory(e.target.value)}
                  value={selectCategory}
                  style={{
                    border: "1px solid #D1D5DB",
                    borderRadius: "8px",
                  }}
                  aria-label="Default select example">
                  <option value="">
                    --ທັງຫມົດ--
                  </option>
                  {!_.isEmpty(newCategoryData) && newCategoryData.map((i) => (
                    <option key={i?.id} value={i?.id}>
                      {i?.name}
                    </option>
                  ))}
                </Form.Select>
            </Col>

            <Col md={2}>
              <Form.Label>ປະເພດລູກຄ້າ</Form.Label>
                <Form.Select
                  name="userType"
                  onChange={(e) => setSelectUserType(e.target.value)}
                  value={selectUserType}
                  style={{
                    border: "1px solid #D1D5DB",
                    borderRadius: "8px",
                  }}
                  aria-label="Default select example">
                  <option value="">
                    --ທັງຫມົດ--
                  </option>
                  {!_.isEmpty(newUserTypeData) && newUserTypeData.map((i) => (
                    <option key={i?.id} value={i?.id}>
                      {i?.name}
                    </option>
                  ))}
                </Form.Select>
            </Col>
            <Col md={2}>
              <Form.Label>ສະຖານະ</Form.Label>
                <Form.Select
                  name="status"
                  onChange={(e) => setStatus(e.target.value)}
                  value={status}
                  style={{
                    border: "1px solid #D1D5DB",
                    borderRadius: "8px",
                  }}
                  aria-label="Default select example">
                  <option value="">--ທັງຫມົດ--</option>
                  <option value="COMPLETED">ຊຳລະເງິນສຳເລັດ</option>
                  <option value="INDEBTED">ຕີດຫນີ້</option>
                </Form.Select>
            </Col>
            <Col md={3}>
              <div style={{ marginTop: 10 }}>ເລືອກວັນທີ</div>
              <Button
                variant="outline-secondary"
                onClick={() => setIsCurrentModals(true)}
                style={{ width: "100%", display: 'flex', gap: 5, justifyContent: 'space-between', alignItems: 'center' }}

              >
                <MdDateRange style={{ fontSize: 25 }} />
                {!cdFillter ? (
                  "mm/dd/yyyy"
                ) : (
                  <>
                    {covertTimeZone(cdFillter?.createdAt_gte) +
                      " ຫາ " +
                      covertTimeZone(cdFillter?.createdAt_lt)}
                  </>
                )}
              </Button>
            </Col>
          </Row>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            padding: '0 2em'
          }}
        >

          <div style={{ display: "flex", gap: 5 }}>
            <CustomButton
              width={200}
              height={40}
              title={"ດາວໂຫຼດ excel"}
              fontSize={"16px"}
              background={"#f2f2f2"}
              border={`1px solid ${APP_COLOR}`}
              color={APP_COLOR}
              icon={<MdDownload style={{ fontSize: 18 }} />}
              onClick={onDownloadToExcelFile}

            />

            {/* <CustomButton
                width={200}
                title={"ດາວໂຫຼດ pdf"}
                fontSize={"16px"}
                background={"#f2f2f2"}
                border={`1px solid ${APP_COLOR}`}
                color={APP_COLOR}
                icon={<MdDownload style={{ fontSize: 18 }} />}
                onClick={onDownloadToPDFFile}
              /> */}
          </div>
          <div style={{ display: "flex", alignItems: "center"}}>
            <p>ຈ/ນທັງຫມົດ: <span style={{ color: "darkolivegreen", fontWeight: "bold" }}>{totalAmount}</span></p>
            <p style={{ marginLeft: 20}}>ຈ/ນເງີນທັງຫມົດ: <span style={{ color: "darkolivegreen", fontWeight: "bold" }}>{numberFormat(subTotal?.kip)}₭ 
              {/* {numberFormat(subTotal?.baht)}฿, {numberFormat(subTotal?.usd)}$ */}
              </span></p>
          </div>
        <Row>
          <Col md={2}>
              <Form.Group   onChange={(e) => handleSelectLimit(e)} style={{minWidth:80}} controlId="exampleForm.ControlInput1">
                {/* <Form.Label>ກຳນົດສະແດງ</Form.Label> */}
                <Form.Select aria-label="select-limit">
                  <option value="25">25</option>
                  <option value="50" selected >50</option>
                  <option value="85">85</option>
                  <option value="100">100</option>
                  <option value="300">300</option>
                  <option value="500">500</option>
                  <option value="1000">1000</option>
                </Form.Select>
              </Form.Group>
            </Col>
            <Col>
              {Pagination_helper(productDeletedTotal, "", ``)}
            </Col>
        </Row>
        </div>

        <div style={{ padding: '0 2em' }}>
          {(loadingOrderGroups && !orderGroupsSale) ? (
            <AnimationLoading />
          ) : (
            <div ref={printRef}>
              <Table
                style={{
                  borderCollapse: "collapse",
                  width: "100% ",
                  background: "#fff",
                }}
              >
                <thead
                  style={{
                    background: LINEAR_GRADIENT_BG,
                    borderRadius: " 8px 8px 0px 0px",
                    color: "#FFFFFF",
                  }}
                >
                  <tr>
                    <th>#</th>
                    <th>ເລກບິນ</th>
                    <th>ຊື່ລູກຄ້າ</th>
                    <th>ນາມສະກຸນ</th>
                    <th>ປະເພດລູກຄ້າ</th>
                    <th>ເບີໂທ</th>
                    <th>ຈຳນວນ</th>
                    <th>ເງິນລວມທັງໝົດ</th>
                    <th>ວັນທີ່, ເດືອນ, ປີ (ເວລາ)</th>
                    <th>ສະຖານະ</th>
                    <th>ຊຳລະ</th>
                    <th>ອໍເດີ້ທັງໝົດ</th>
                  </tr>
                </thead>
                <tbody>
                  {orderGroups.map((item, index) => (
                    <tr key={index}>
                      <td>
                        {index + 1 + _limit * (_skip - 1)}
                      </td>
                      <td>
                        <div
                          className="d-flex flex-column"
                          style={{ minWidth: 130 }}
                        >
                          <div style={{ fontSize: 26 }}>
                            <b>{item?.code ?? "-"}</b>
                          </div>

                          <div className="d-flex">
                            <CustomButton
                              width="auto"
                              title={"ພິມບິນ"}
                              padding={".5em"}
                              fontSize={"12px"}
                              background={"green"}
                              color="#fff"
                              icon={<MdPrint style={{ fontSize: 18 }} />}
                              onClick={() => onViewOrderGroups(item)}
                            />
                          </div>
                        </div>
                      </td>
                      <td>{item?.customerName ?? "-"}</td>
                      <td>{item?.customerLastName ?? "-"}</td>
                      <td> <p style={{ color: "darkolivegreen", fontWeight: "bold" }}>{item?.userConfirm?.userType?.name ?? "-"}</p></td>
                      <td>{item?.phone ?? "-"}</td>
                      <td>{item?.amount ?? "-"}</td>
                      <td>
                        {convertCurrency("LAK")} {numberFormat(calculateSumInLAKFromOrders(item?.orders))}
                      </td>
                      <td>{covertTimeZone(item?.createdAt)}</td>
                      <td onClick={(e) => e.stopPropagation()}>
                        {item?.status === "COMPLETED" ? (
                          <div style={{ color: "green" }}>ຂາຍສຳເລັດ</div>
                        ) : item?.status === "NOTYETPAID" ? (
                          <div style={{ color: "tomato" }}>
                            ຍັງບໍ່ທັນຈ່າຍເງີນ
                          </div>
                        ) : item?.status === "INDEBTED" ? (
                          <div style={{ color: "red" }}>ຕິດໜິ້</div>
                        ) : (
                          <>ສົ່ງຄືນສິນຄ້າ</>
                        )}

                        {item?.status === "NOTYETPAID" && (
                          <CustomButton
                            width="auto"
                            title={"ລາຍລະອຽດ"}
                            padding={".5em"}
                            fontSize={"12px"}
                            background={"red"}
                            color="#fff"
                            onClick={() =>
                              history.push("/order_detail", {
                                state: item,
                              })
                            }
                          />
                        )}
                      </td>
                      <td>
                        {item?.payment === "CASH" ? "ເງິນສົດ" : "ເງິນໂອນ"}
                      </td>
                      <td>
                        <div>
                          <Table>
                            <tbody>
                              {item?.orders.map((e, indx) => (
                                <tr key={indx}>
                                  <td style={{ padding: 1 }}>
                                    <small>{indx + 1}.</small>
                                  </td>
                                  <td style={{ padding: 1 }}>
                                    <small>{e?.productName}</small>
                                  </td>
                                  <td style={{ padding: "1px 10px" }}>
                                    <small> ( {e?.amount} )</small>
                                  </td>
                                  <td style={{ padding: 1 }}>
                                  <small>
                                    {(() => {
                                      const basePrice = Number(e?.price || 0);
                                      const optionsPrice = (e?.options?.length > 0 
                                        ? e?.options.reduce((sum, p) => sum + (Number(p?.price) || 0), 0)
                                        : 0
                                      ) // * (Number(e?.amount) || 1);
                                      
                                      const totalPrice = basePrice + optionsPrice;
                                      
                                      return `${numberFormat(totalPrice)} ${e?.currency || ''}`;
                                    })()}
                                  </small>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          )}
          {/* <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            {!loadingOrderGroups ? (
              <div style={{ display: "flex", gap: 5 }}>
                <CustomButton
                  width={200}
                  title={"ດາວໂຫຼດ excel"}
                  fontSize={"12px"}
                  padding={".5em 1em"}
                  background={"#f2f2f2"}
                  border={`1px solid ${APP_COLOR}`}
                  color={APP_COLOR}
                  icon={<MdDownload style={{ fontSize: 18 }} />}
                  onClick={onDownloadToExcelFile}
                />

                <CustomButton
                  width={200}
                  title={"ດາວໂຫຼດ pdf"}
                  fontSize={"12px"}
                  padding={".5em 1em"}
                  background={"#f2f2f2"}
                  border={`1px solid ${APP_COLOR}`}
                  color={APP_COLOR}
                  icon={<MdDownload style={{ fontSize: 18 }} />}
                  onClick={onDownloadToPDFFile}
                />
              </div>
            ) : <div></div>}
            {Pagination_helper(productDeletedTotal, "", ``)}
          </div> */}
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "1em 2em",
          }}
        >
          {/* {productDeletedTotal && (
            <div className="show">
              ກຳລັງສະແດງ {50 * _skip - 49}-
              {50 * _skip > productDeletedTotal
                ? productDeletedTotal
                : 50 * _skip}{" "}
              ຈາກ {productDeletedTotal}
            </div>
          )} */}
          {/* <div>{Pagination_helper(productDeletedTotal, "", ``)}</div> */}
        </div>
      </div>

      <CurrentDateComponents
        onCloseModal={() => setIsCurrentModals(false)}
        openModal={isCurrentModals}
        setCdFillter={setCdFillter}
        setActiveButton={setActiveButton}
        activeButton={activeButton}
      />

      <ComfirmModal
        showConfirmModal={openRecoverComfirm}
        handleCancel={() => setOpenRecoverComfirm(false)}
        // handleConfirm={_ReturnOrderGroup}
        handleConfirm={handleRecoverProductOld}
        loadingConfirm={loadingRecover}
        title="ແຈ້ງເຕືອນ"
        text="ຕ້ອງການກູ້ຄືນສິນຄ້າເຫຼົ່ານີ້ບໍ!"
      />

      <ComfirmModal
        showConfirmModal={openComfirmModal}
        handleCancel={() => setOpenComfirmModal(false)}
        // handleConfirm={_ReturnOrderGroup}
        handleConfirm={deletedProductFormDB}
        loadingConfirm={loadingDeleted}
        title="ແຈ້ງເຕືອນ"
        text="ທ່ານຕ້ອງການລືບສິນຄ້າທັງໝົດນີ້ບໍ!"
      />

      <Modal show={openBillOrder} onHide={() => setOpenBillOrder(false)}>
        <Modal.Body style={{ display: "flex", justifyContent: "center" }}>
          <div style={{ width: "80mm", padding: 4 }} ref={bill80Ref}>
            <BillforSale80 Location={Location} ordergroup={preOrderGroups} prepareRate={exchangeRateData?.exchangeRate} />
          </div>
        </Modal.Body>
        <Modal.Footer
          style={{ display: "flex", justifyContent: "space-between", gap: 10 }}
        >
          <CustomButton
            width={100}
            height={42}
            borderRadius={4}
            background="transparent"
            color="#3C169B"
            border="1px solid #3C169B "
            fontweight={400}
            title={"ຍົກເລີກ"}
            onClick={() => setOpenBillOrder(false)}
          />
          <CustomButton
            width={175}
            height={42}
            background={LINEAR_GRADIENT_BG}
            borderRadius={4}
            title={"ປິ້ນ Internet"}
            onClick={() => onPrintBill()}
          />
          <ReactToPrint
            trigger={() => (
              <CustomButton
                width={175}
                height={42}
                background={LINEAR_GRADIENT_BG}
                borderRadius={4}
                title={"ປິ້ນ USB"}
              // onClick={() => onPrintBill()}
              />
            )}
            content={() => bill80Ref.current}
          />
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
}
